// extracted by mini-css-extract-plugin
module.exports = {"aboutSection":"About_aboutSection__37TnF","gridImgCont":"About_gridImgCont__2CO_z","galleryCont":"About_galleryCont__1yjHy"};